import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["dialogClassName", "className", "clsPrefix", "size", "style", "contentStyle", "children", "draggable", "resizable", "resizeClassName", "minHeight", "minWidth", "bounds", "clearCenteredCls", "zIndex", "tempHide"];

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.number.max-safe-integer.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.string.ends-with.js";
import "core-js/modules/es6.number.is-nan.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classNames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import Resizable from 're-resizable';
import omit from "omit.js";
import { WebUI, prefix } from "../../wui-core/src/index.js";

function getPos(obj) {
  var pos = {
    left: 0,
    top: 0
  };

  while (obj) {
    pos.left += obj.offsetLeft ? obj.offsetLeft : 0;
    pos.top += obj.offsetTop ? obj.offsetTop : 0;
    obj = obj.offsetParent;
  }

  return pos;
}

var propTypes = {
  /**
   * 传给dialog的classname
   */
  dialogClassName: PropTypes.string,
  contentStyle: PropTypes.object,
  onStart: PropTypes.func,
  onStop: PropTypes.func
};
var defaultProps = {
  minHeight: 150,
  minWidth: 200,
  clsPrefix: "".concat(prefix, "-modal"),
  bounds: null,
  onStart: function onStart() {},
  onStop: function onStop() {}
};
var ModalDialog = (_dec = WebUI({
  name: "modal",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalDialog, _React$Component);

  var _super = _createSuper(ModalDialog);

  function ModalDialog() {
    var _this;

    _classCallCheck(this, ModalDialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "resized", false);

    _defineProperty(_assertThisInitialized(_this), "state", {
      draging: false,
      draged: false,
      original: {
        x: 0,
        y: 0
      },
      maxWidth: Number.MAX_SAFE_INTEGER,
      maxHeight: Number.MAX_SAFE_INTEGER
    });

    _defineProperty(_assertThisInitialized(_this), "onStart", function (event) {
      var _this$props = _this.props,
          draggable = _this$props.draggable,
          resizable = _this$props.resizable,
          centered = _this$props.centered;

      _this.setState({
        draging: true
      });

      var transfromDom = _this.resizable && _this.resizable.resizable || _this.resize;
      var pos = getPos(transfromDom);
      var transform = transfromDom.style && transfromDom.style.transform; // reg1 = /translate\((\d+)?px, (\d+)?px\)/;
      // 'translate(420px, 30px)'.match(reg1)
      // 兼容含有拖拽功能，点击模态框头部，开始突然往左上角抖一下的问题
      // 如果是resize了，那么就会有一定的偏移，这个transform也有值了

      if (!transform || transform == 'translate(0px, 0px)' || transform == 'translate(0px)' || _this.resized) {
        if (draggable && resizable && centered) {
          var a = transfromDom.getBoundingClientRect();
          transfromDom.style.transform = "translate(".concat(Math.floor(a.x), "px, ").concat(Math.floor(a.y), "px)");
        } else {
          transfromDom.style.transform = "translate(".concat(Math.floor(pos.left), "px, ").concat(Math.floor(pos.top), "px)");
        }

        _this.resized = false;
      }

      _this.props.onStart();

      if (event) {
        event.stopPropagation(); // 两个可拖拽modal嵌套的时候，事件冒泡会引起两个可拖拽modal一起动
      }

      return draggable;
    });

    _defineProperty(_assertThisInitialized(_this), "onStop", function (e, delta) {
      // let dialogWidth = this.modalDialog && this.modalDialog.offsetWidth;
      // let clientWidth = e && e.target && e.target.clientWidth;
      // if(delta.x > 0 && clientWidth - delta.x < 50){
      //   return
      // }
      // if(delta.x < 0 && dialogWidth + delta.x < 50){
      //   return
      // }
      // if(delta.y < 0 ){
      //   return
      // }
      _this.setState({
        draged: true,
        draging: false,
        original: {
          x: Math.floor(delta.x),
          y: Math.floor(delta.y)
        }
      });

      _this.props.onStop();
    });

    _defineProperty(_assertThisInitialized(_this), "onResizeStart", function (e, dir, elementRef) {
      var onResizeStart = _this.props.onResizeStart;
      typeof onResizeStart === "function" && onResizeStart(e, dir, elementRef);
      _this.props.clearCenteredCls && _this.props.clearCenteredCls();
    });

    _defineProperty(_assertThisInitialized(_this), "onResize", function (e, direction, elementRef, delta) {
      var onResize = _this.props.onResize;
      var original = _this.state.original;
      /* resize 之前的值 */

      var originX = original.x;
      var originY = original.y;
      /* 移动的位移 */

      var moveW = delta.width;
      var moveH = delta.height;
      /* 移动的位移 */

      var x = null,
          y = null;
      /* 处理上边缘 */

      if (/left/i.test(direction)) {
        x = originX - moveW;
        y = originY;
        _this.position = {
          x: x,
          y: y
        };
        /* 处理左边缘 */
      } else if (/top/i.test(direction)) {
        x = originX;
        y = originY - moveH;
        _this.position = {
          x: x,
          y: y
        };
      } else {
        _this.position = null;
      }

      if (x || y) {
        var modifiedX = Math.floor(x);
        var modifiedY = Math.floor(y);
        elementRef.style.transform = "translate(".concat(modifiedX, "px, ").concat(modifiedY, "px)");
      }

      if (delta.height) {
        _this.updateBodyH();
      }

      typeof onResize === "function" && onResize(e, direction, elementRef, delta);
    });

    _defineProperty(_assertThisInitialized(_this), "onResizeStop", function (e, direction, elementRef, delta) {
      var onResizeStop = _this.props.onResizeStop;

      if (_this.position) {
        _this.setState({
          original: _this.position
        });
      }

      typeof onResizeStop === "function" && onResizeStop(e, direction, elementRef, delta);
      _this.resized = true;
    });

    _defineProperty(_assertThisInitialized(_this), "updateBodyH", function () {
      var $resizable = ReactDOM.findDOMNode(_this.resizable);
      var $header = $resizable.querySelector(".".concat(prefix, "-modal-header"));
      var $body = $resizable.querySelector(".".concat(prefix, "-modal-body"));
      var $footer = $resizable.querySelector(".".concat(prefix, "-modal-footer"));
      var totalH = $resizable.style.height;
      totalH = Number(totalH.replace("px", ""));

      if ($header) {
        totalH -= $header.offsetHeight;
      }

      if ($footer) {
        totalH -= $footer.offsetHeight;
      }

      $body.style.height = "".concat(totalH, "px");
    });

    _defineProperty(_assertThisInitialized(_this), "getMaxSizesFromProps", function () {
      var backDropW = _this.backdrop && _this.backdrop.offsetWidth ? _this.backdrop.offsetWidth : Number.MAX_SAFE_INTEGER;
      var backDropH = _this.backdrop && _this.backdrop.offsetHeight ? _this.backdrop.offsetHeight : Number.MAX_SAFE_INTEGER;
      var maxWidth = typeof _this.props.maxWidth === "undefined" ? backDropW : _this.props.maxWidth;
      var maxHeight = typeof _this.props.maxHeight === "undefined" ? backDropH : _this.props.maxHeight;
      return {
        maxWidth: maxWidth,
        maxHeight: maxHeight
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleWH", function (value) {
      var size = value;

      if (typeof value === "string" && value.endsWith("px")) {
        size = Number(value.replace("px", ""));
      } else if (typeof Number(value) === "number" && !Number.isNaN(Number(value))) {
        size = Number(value);
      }

      return size;
    });

    _defineProperty(_assertThisInitialized(_this), "renderModalContent", function () {
      var _this$props2 = _this.props,
          clsPrefix = _this$props2.clsPrefix,
          children = _this$props2.children,
          resizable = _this$props2.resizable,
          contentStyle = _this$props2.contentStyle,
          minHeight = _this$props2.minHeight,
          minWidth = _this$props2.minWidth,
          resizeClassName = _this$props2.resizeClassName;
      var _this$state = _this.state,
          maxWidth = _this$state.maxWidth,
          maxHeight = _this$state.maxHeight;

      if (!resizable) {
        return /*#__PURE__*/React.createElement("div", {
          style: contentStyle,
          className: classNames(["".concat(clsPrefix, "-content")]),
          role: "document",
          ref: function ref(_ref) {
            return _this.resize = _ref;
          }
        }, children);
      }

      var _minWidth = _this.handleWH(minWidth);

      var _minHeight = _this.handleWH(minHeight);

      return /*#__PURE__*/React.createElement(Resizable, {
        className: resizeClassName,
        ref: function ref(c) {
          if (c) {
            _this.resizable = c;
          }
        },
        onResizeStart: _this.onResizeStart,
        onResize: _this.onResize,
        onResizeStop: _this.onResizeStop,
        minWidth: _minWidth,
        minHeight: _minHeight,
        maxWidth: _this.handleWH(maxWidth),
        maxHeight: _this.handleWH(maxHeight)
      }, /*#__PURE__*/React.createElement("div", {
        style: _objectSpread(_objectSpread({}, contentStyle), {}, {
          minHeight: _minHeight,
          height: "100%"
        }),
        className: classNames(["".concat(clsPrefix, "-content")]),
        role: "document",
        ref: function ref(_ref2) {
          return _this.resize = _ref2;
        }
      }, children));
    });

    return _this;
  }

  _createClass(ModalDialog, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.resizable) {
        var _this$getMaxSizesFrom = this.getMaxSizesFromProps(),
            maxWidth = _this$getMaxSizesFrom.maxWidth,
            maxHeight = _this$getMaxSizesFrom.maxHeight;

        if (maxWidth != this.state.maxWidth) {
          this.setState({
            maxWidth: maxWidth,
            maxHeight: maxHeight
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _dialogClasses,
          _this2 = this;

      var _this$props3 = this.props,
          dialogClassName = _this$props3.dialogClassName,
          className = _this$props3.className,
          clsPrefix = _this$props3.clsPrefix,
          size = _this$props3.size,
          style = _this$props3.style,
          contentStyle = _this$props3.contentStyle,
          children = _this$props3.children,
          draggable = _this$props3.draggable,
          resizable = _this$props3.resizable,
          resizeClassName = _this$props3.resizeClassName,
          minHeight = _this$props3.minHeight,
          minWidth = _this$props3.minWidth,
          bounds = _this$props3.bounds,
          clearCenteredCls = _this$props3.clearCenteredCls,
          zIndex = _this$props3.zIndex,
          tempHide = _this$props3.tempHide,
          props = _objectWithoutProperties(_this$props3, _excluded);

      var _this$state2 = this.state,
          original = _this$state2.original,
          maxWidth = _this$state2.maxWidth,
          maxHeight = _this$state2.maxHeight,
          draging = _this$state2.draging,
          draged = _this$state2.draged;

      var uClassName = _defineProperty({}, "".concat(clsPrefix), true);

      var modalStyle = {
        display: tempHide ? 'none' : 'block'
      };

      if (zIndex) {
        modalStyle.zIndex = zIndex;
      }

      var dialogClasses = (_dialogClasses = {}, _defineProperty(_dialogClasses, uClassName, false), _defineProperty(_dialogClasses, "".concat(clsPrefix, "-dialog"), true), _dialogClasses);

      if (size) {
        dialogClasses["".concat(clsPrefix, "-").concat(size)] = true;
      }

      if (draggable) {
        dialogClasses["".concat(clsPrefix, "-draggable")] = true;
      }

      if (draging) dialogClasses["".concat(clsPrefix, "-draging")] = true;
      if (draged) dialogClasses["".concat(clsPrefix, "-draged")] = true;
      return /*#__PURE__*/React.createElement("div", _extends({}, omit(props, ['title', 'okButtonProps', 'okText', 'cancelText', 'okType', 'cancelButtonProps']), {
        tabIndex: "-1",
        role: "dialog",
        style: modalStyle,
        ref: function ref(_ref4) {
          return _this2.backdrop = _ref4;
        },
        className: classNames(className, uClassName)
      }), /*#__PURE__*/React.createElement("div", {
        className: classNames(dialogClassName, dialogClasses),
        style: style,
        ref: function ref(_ref3) {
          return _this2.modalDialog = _ref3;
        }
      }, draggable ? /*#__PURE__*/React.createElement(Draggable, {
        handle: ".dnd-handle",
        cancel: ".dnd-cancel",
        bounds: bounds //防止拖拽时，Header 被导航栏覆盖
        ,
        onStart: this.onStart,
        onStop: this.onStop,
        position: original,
        list: []
      }, this.renderModalContent()) : this.renderModalContent()));
    }
  }]);

  return ModalDialog;
}(React.Component)) || _class);
ModalDialog.propTypes = propTypes;
export default ModalDialog;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-modal/src/ModalDialog.js